import { createSlice } from "@reduxjs/toolkit";



const initialState = {
    companyDetail: {},

};

const companyDetailSlice = createSlice({

    name: "companyDetail",
    initialState,
    reducers: {
        setCompanyDetail: (state, action) => {
            

            state.companyDetail = action.payload;

        },


    },
});

export const {
    setCompanyDetail

} = companyDetailSlice.actions;
export default companyDetailSlice.reducer;
